<template>
  <div>
    <a-select
      :value="value"
      allow-clear
      show-search
      :multiple="false"
      :placeholder="placeholder"
      option-filter-prop="title"
      @change="onChange"
      @clear="onClear"
      :class="class"
      :disabled="disabled"
    >
      <a-select-option
        v-for="item in data?.records"
        :key="item.id"
        :value="item.id"
        :title="item.name"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { ProjectTypeService } from "@/views/project-config/project-type/project-type.service";

/**
 * 项目类型选择器
 * <project-type-select v-model:value="formRef.projectTypeId"></project-type-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "ProjectTypeSelect",
  props: {
    placeholder: {
      type: String,
      default: "请选择",
    },
    value: {
      type: String,
      default: undefined,
    },
    class: {
      type: String,
      default: "append-to-parent",
    },
    disabled:{
      type: Boolean,
      default:false
    },
    list:{
      type:Array,
      default:()=>[]
    }
  },
  emits: ["update:value","update:list"],
  setup(props, { attrs, slots, emit }) {
    const { data, run, loading } = ProjectTypeService.useSimpleListApi();

    const onChange = (id) => {
      emit("update:value", id);
    };

    const onClear = () => {
      emit("update:value", "");
    };

    onMounted(async () => {
      await run();
      emit("update:list",data.value?.records)
    });

    return {
      data,
      loading,
      onChange,
      onClear,
    };
  },
});
</script>
